// Import Vue
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
import Vue from 'vue';
import Framework7 from './framework7-custom.js';

import io from 'socket.io-client';
window.io = io;
import VueEcho from 'vue-echo-laravel';
import wysiwyg from 'vue-wysiwyg';
import { WebRTC } from 'vue-webrtc';

import store from '@/store/index.js';
import App from '@/components/App.vue';
import '@/css/framework7-custom.less';
import '@/css/app.less';
import '@/css/icons.css';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
// import "framework7-icons/css/framework7-icons.css";

import 'babel-polyfill';
import 'webrtc-adapter';

import { WS_BASE_PATH } from '@/js/constants/index.js';

Framework7.use(Framework7Vue);

Vue.use(VueEcho, {
  client: io,
  broadcaster: 'socket.io',
  host: WS_BASE_PATH,
  auth: {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  }
});

Vue.component(WebRTC.name, WebRTC);
Vue.use(wysiwyg, {});

Vue.filter('two_digits', value => {
  if (value < 0) {
    return '00';
  }
  if (value.toString().length <= 1) {
    return `0${value}`;
  }
  return value;
});

// Init App
export default new Vue({
  el: '#app',
  store,

  // Register App Component
  components: {
    app: App
  },
  render: h => h(App)
});
